import { Component, OnInit } from '@angular/core';
import { SettingsService } from '../../services/settings/settings.service';


@Component({
  selector: 'app-settings-modal',
  templateUrl: './settings-modal.component.html',
  styleUrls: ['./settings-modal.component.scss']
})
export class SettingsModalComponent implements OnInit {
  surveyRootFolderPath: string;
  databaseSeverName: string;
  applicationBaseUrl: string;

  constructor(private settingsService: SettingsService) { }

  ngOnInit() {
    this.settingValues();
  }
  settingValues(){
    this.settingsService.settingValues().subscribe((data: {}) => {
      this.surveyRootFolderPath = data['SurveyRootFolderPath']; 
      this.databaseSeverName = data['DatabaseServerName'];   
      this.applicationBaseUrl = data['ApplicationBaseUrl']; 
    });
  }

}
